export const ANONYMOUS_DEVICE_ID="anonymous_uniswap_user";